import {useCallback} from 'react';
import pageLifecycle from 'page-lifecycle';

import EventListener from 'topmeteo/general/components/EventListener';

import {URL, getBody} from './utils';

const Transmitter = ({dataRef, timerRef, children}) => {
    const handlePageStateChange = useCallback(
        ({newState}) => {
            if (newState === 'hidden') {
                if (timerRef.current) clearTimeout(timerRef.current);

                if (dataRef.current.length) {
                    const data = getBody(dataRef.current);
                    const result = navigator.sendBeacon(URL, data);

                    if (result) dataRef.current = [];
                }
            }
        },
        [dataRef, timerRef],
    );

    return (
        <EventListener target={pageLifecycle} onStateChange={handlePageStateChange}>
            {children}
        </EventListener>
    );
};

export default Transmitter;
